import classNames from 'classnames'
import { NextPageContext } from 'next'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import Button from '../../../components/_legacy/Button'
import Col from '../../../components/basic/Col'
import BasicHead from '../../../components/common/BasicHead'
import CenterContainer from '../../../components/common/CenterContainer'
import DeviceSplit from '../../../components/common/DeviceSplit'
import EmptyBlock from '../../../components/common/EmptyBlock'
import Span from '../../../components/common/Span'
import VWContainer from '../../../components/common/VWContainer'
import LandingNav from '../../../components/landing/navigation/LandingNav'
import MobileLandingNav from '../../../components/landing/navigation/LandingNav/MobileLandingNav'
import Footer from '../../../components/landing/section/footer'
import { InitialProps } from '../../../model/Common/common.interface'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import LinkLocale from '../../../modules/i18n/LinkLocale'
import { LOCALE_KO } from '../../../modules/i18n/config'
import useTranslation from '../../../modules/i18n/useTranslation'
import {
  CULTURE_1,
  CULTURE_2,
  CULTURE_3,
  IC_CHEVRON_DOWN,
  JOIN_US,
  OFFICE_PENNSYLVANIA,
  OFFICE_SANMATEO,
  OFFICE_SEATTLE,
  OFFICE_SEOUL,
  OFFICE_SYDNET,
  TEAM_A,
  TEAM_E,
  TEAM_G,
  TEAM_MAIN,
  TEAM_R,
  TEAM_T,
} from '../../../modules/images'
import urls from '../../../modules/urls'
import { getOgUrl } from '../../../modules/utils'

type SectionPropsType = {
  title: any
  main: any
  isFirst: any
  content?: any
  description?: any
}

const Section = ({ title, main, isFirst, content = '', description = '' }: SectionPropsType) => {
  const [isMobile, setIsMobile] = useState(true)

  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])

  return (
    <div className={classNames(isMobile ? 'mb-8 text-left' : 'text-left', 'relative')}>
      {!isFirst && !isMobile && <div className="relative top-[20px] left-1/2 h-[100px] w-[1px] bg-gray-200"></div>}
      <div className={classNames(isMobile ? 'justify-center' : 'justify-center pt-48 text-center', 'row')}>
        <Col
          clx={
            isMobile ? 'text-purple-500 text-sBody mb-0 col-12' : 'text-purple-500 text-h2 font-bold mb-0 text-center'
          }
        >
          {title}
          {isMobile && <hr className="m-0" />}
        </Col>
      </div>
      <div className="row justify-center">
        <Col
          clx={
            isMobile
              ? 'mt-16 mb-12 text-black text-h3 col-12 font-medium'
              : 'text-d4 mt-32 mb-16 !col-10 text-center font-bold'
          }
        >
          {main}
        </Col>
      </div>
      {description && (
        <div className="row justify-center">
          <Col
            clx={
              isMobile
                ? 'font-regular text-gray-700 col-12 text-sBody mb-[20px]'
                : 'font-medium text-gray-700 col-10 text-center mb-[60px]'
            }
          >
            {description}
          </Col>
        </div>
      )}
      {content && (
        <div className="row justify-center">
          <Col clx="col-12">
            <div>{content}</div>
          </Col>
        </div>
      )}
    </div>
  )
}

type SubSectionPropsType = {
  title: any
}

const SubSection = ({ title }: SubSectionPropsType) => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  const { t } = useTranslation()

  return <p className={isMobile ? 'text-sBody mb-12 text-left' : 'text-h2 mb-48 text-center font-bold'}>{t(title)}</p>
}

const Welcome = () => {
  const { t } = useTranslation()
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)

  return (
    <>
      <section
        style={{
          backgroundImage: `url(${TEAM_MAIN})`,
          height: isMobile ? 218 : 455,
        }}
        className={
          isMobile
            ? 'py-md-12 jarallax full-img mb-16 bg-cover py-10'
            : 'py-md-12 jarallax w-100 bg-cover bg-bottom py-10'
        }
      ></section>
    </>
  )
}

const Great = () => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  const content = [
    {
      title: 'G',
      image_url: TEAM_G,
      full_title: 'Genuine',
      content: ['정직하고 솔직한', ''],
      detail: ['Fact 와 진심이 만들어내는 신뢰를 지향합니다', 'We seek and share honest truths'],
    },
    {
      title: 'R',
      image_url: TEAM_R,
      full_title: 'Result-Oriented',
      content: ['결과를 만들어 내는', ''],
      detail: ['결과물 개선을 중심으로 효율/효과적으로 업무합니다', 'We work efficiently to produce tangible results'],
    },
    {
      title: 'E',
      image_url: TEAM_E,
      full_title: 'Extra two-mile',
      content: ['한계를 극복하는', ''],
      detail: [
        "'이게 최선일까?' 한 번 더 고민해 최고를 만들어냅니다",
        `We challenge ourselves to go further than our best`,
      ],
    },
    {
      title: 'A',
      image_url: TEAM_A,
      full_title: 'Accountability',
      content: ['주체적이고 책임감있는', ''],
      detail: [
        '스스로 문제를 찾고, 솔루션을 제안하며, 실행해 냅니다',
        'We put it on ourselves to bring work to the finish line',
      ],
    },
    {
      title: 'T',
      image_url: TEAM_T,
      full_title: 'Team-Based Problem Solving',
      content: ['팀과 함께 만들어내는', ''],
      detail: ['성숙한 소통과 협업을 통해 함께 만들어 나갑니다', 'We commit to moving forward as a united team '],
    },
  ]
  const { t } = useTranslation()
  const [activeId, setActiveId] = useState(0)
  return (
    <div className={classNames(isMobile ? 'mt-40 justify-center' : 'mt-32 mb-80 justify-center', 'row')}>
      {isMobile ? (
        <>
          <Slider
            autoplay={true}
            autoplaySpeed={3000}
            slidesToShow={1}
            slidesToScroll={1}
            infinite={true}
            cssEase="linear"
            className="great-slider mb-56"
            dots={true}
            draggable={true}
            nextArrow={
              <div className="great-slick-next h-[20px] w-[20px]">
                <img src={IC_CHEVRON_DOWN} width={20} />
              </div>
            }
            prevArrow={
              <div className="great-slick-prev h-[20px] w-[20px]">
                <img src={IC_CHEVRON_DOWN} width={20} />
              </div>
            }
            lazyLoad={'ondemand'}
            beforeChange={(current, next) => setActiveId(next)}
            customPaging={function (i = activeId) {
              return (
                <a>
                  <div
                    onClick={() => setActiveId(i)}
                    className={classNames([i == activeId ? 'w-16' : ' w-6'], 'mt-[10px] h-[6px] rounded-full')}
                  ></div>
                </a>
              )
            }}
          >
            {content.map((item, i) => (
              <div key={i} className="overflow-visible bg-white">
                <div className="flex h-[180px] items-center rounded-lg border px-12 py-16 shadow-lg">
                  <img src={item.image_url} alt="Great" width={80} height={80} />
                  <div className="pl-12">
                    {/* <img
                      src={IC_CHEVRON_DOWN}
                      style={{ transform: 'translate(90)', background: 'red' }}
                      className="max-w-none"
                    /> */}
                    <div className=" text-black">{item.full_title}</div>
                    <div className="text-sBody mb-12 text-black">{t(item.content)}</div>
                    <div className="text-h6 text-gray-700">{t(item.detail)}</div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </>
      ) : (
        content.map((item, i) => (
          <Col
            key={i}
            clx={classNames('col-2 flex flex-col content-center items-center px-0 text-center ', {
              '!important mr-0': i === content.length - 1,
              '!important mr-24': i !== content.length - 1,
            })}
          >
            <div>
              <img src={item.image_url} width={95} height={95} />
            </div>
            <div className="min-2-line flex h-[48px] items-center justify-center font-bold">{item.full_title}</div>
            <div className="my-12 font-medium">{t(item.content)}</div>
            <div className="text-h5 mt-3 text-gray-500">{t(item.detail)}</div>
          </Col>
        ))
      )}
    </div>
  )
}

const HiringSection = () => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  const { t } = useTranslation()

  return (
    <>
      <Section
        isFirst={false}
        title={t(['Open Position', 'Open Position'])}
        main={t([<>링글은 전 직군 채용중입니다</>, `We're hiring!`])}
      />
    </>
  )
}
type OfficePropsType = {
  title: any
  address: any
  imageUrl: string
  description: any
}

const Office = ({ title, address, imageUrl, description }: OfficePropsType) => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  const { t } = useTranslation()
  return (
    <div className={classNames(isMobile ? 'mb-8' : 'mb-84')}>
      <div className="mb-12">
        <img src={imageUrl} className="md:h-358 w-full" />
      </div>
      {isMobile ? (
        <div className="row mb-[46px] flex">
          <Col clx="flex flex-col col-12">
            <div className="font-medium">
              <Span size={20} className="font-medium ">
                {title}
              </Span>
            </div>
            <div className="text-h6 mb-8 text-gray-700">{address}</div>
          </Col>
          <Col clx="text-gray-700 col-12 pr-0 word-break-keepall text-h6">{t(description)}</Col>
        </div>
      ) : (
        <div className="row mt-4 flex">
          <Col clx="flex flex-col col-3">
            <div className="font-medium">
              <Span size={40} className="font-medium ">
                {title}
              </Span>
            </div>
            <div className="text-sBody text-gray-700">{address}</div>
          </Col>
          <Col clx="text-black col-6 pr-0 word-break-keepall text-sBody flex justify-end items-end">
            <div className="border-l border-gray-300 pl-[16px]">{t(description)}</div>
          </Col>
        </div>
      )}
    </div>
  )
}

type SubOfficePropsType = {
  title: any
  imageUrl: string
  description: any
}

const SubOffice = ({ title, imageUrl, description }: SubOfficePropsType) => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)

  return (
    <>
      {isMobile ? (
        <>
          <Col clx="col-6 mb-12">
            <div className="overflow-hidden">
              <img src={imageUrl} className="w-full" />
            </div>
          </Col>
          <Col clx="col-6 mb-12 pl-0">
            <Span size={18}>{title}</Span>
            <div className="text-h6 mt-2 text-gray-700">{description}</div>
          </Col>
        </>
      ) : (
        <Col clx="mb-84 col-4">
          <div style={{ height: '300px' }} className="overflow-hidden">
            <img src={imageUrl} className="w-full" />
          </div>
          <div className="mt-4">
            <div className="font-bold">
              <Span size={24}>{title}</Span>
            </div>
            <div className="text-gray-700">{description}</div>
          </div>
        </Col>
      )}
    </>
  )
}

const DepartmentCard = ({ department }) => {
  const { isLocaleKO } = useTranslation()
  return (
    <LinkLocale href={urls.company.detail(department.id)}>
      <div className="border-1 active:border-1 relative min-h-[136px] cursor-pointer rounded-[5px] border-gray-300 p-[16px] active:border-purple-500 active:bg-gray-50 sm:min-h-[159px]">
        <div className="text-[14px] font-bold text-black active:text-purple-500 sm:text-[20px]">
          {department.team_name}
        </div>
        <div className="mt-[8px] text-[12px] text-gray-500 sm:text-[14px]">
          {isLocaleKO ? department.title : department.title_en}
        </div>
        <div className="absolute hidden text-[14px] font-medium text-gray-700 active:text-purple-500 sm:bottom-12 sm:right-16 sm:block">
          See detail
        </div>
        <div className="absolute top-12 right-12 text-[14px] font-medium text-gray-700 active:text-purple-500 sm:hidden">
          See detail
        </div>
      </div>
    </LinkLocale>
  )
}

const TeamBody = ({ departments }: { departments: any }) => {
  const router = useRouter()
  const listRef = useRef(null)
  const [isMobile, setIsMobile] = useState(true)

  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])

  useEffect(() => {
    if (router.asPath.endsWith('list')) {
      window.scrollTo(0, listRef.current.offsetTop + 10)
    }
  }, [router, listRef, departments, isMobile])

  const sectionTexts = [
    {
      title: ['링글팀의 미션', `Our Mission `],
      main: [
        <div className={isMobile ? ' ' : 'display-3'} key={'first'}>
          링글은 누구나 영어의 장벽을 넘어 더 큰 기회를 잡을 수 있는 세상을 만듭니다
        </div>,
        <div className={isMobile ? ' ' : 'display-3'} key={'second'}>
          Our mission is to break down language barriers and allow talented individuals to exchange knowledge and help
          each other grow.
        </div>,
      ],
      description: [
        <>
          링글팀은, 차별화 된 튜터, 콘텐트, 기술을 바탕으로, 진짜 배우고 성장할 수 있는 {isMobile || <br />}
          서비스 구현을 통한 전 세계 No.1 Edu-Tech 사 도약에 도전합니다.
        </>,
        <>
          Ringle team aims to become the world’s number one EdTech company by creating a service that fosters true
          learning and growth through our selective tutors, contents and technology.
        </>,
      ],
    },
    {
      title: ['링글팀의 인재상', `Core Values`],
      main: [<>GREAT 한 어른형 인재를 지향합니다</>, <>We value GREAT people</>],
      description: [
        <>
          링글은 스스로 기획-판단-실행-소통하며, 팀과 함께 세계적 서비스를 만들어 나가는, {isMobile || <br />}
          체계적/창의적/성숙한 팀플레이어를 지향합니다.
        </>,
        <>
          Ringle runs on an effective, creative and powerful teamplay supported by individual responsibilities and
          initiatives.
        </>,
      ],
    },
    {
      title: ['링글 팀 소개', 'Team'],
      main: [
        <>링글팀은 소수 정예 멤버가 큰 변화를 만들고 있습니다.</>,
        <>We are a small team making a huge difference</>,
      ],
      description: [
        <>
          링글팀은 한국-미국을 거점으로 소수 정예로 구성되어 있습니다.
          {!isMobile && <br />}한 명 한 명이 큰 프로젝트들을 2개 이상 책임지고 있으며, 누구나 새로운 업무에 도전할 수
          있습니다.
          {!isMobile && <br />} 무엇보다도 너무 좋은 사람들입니다.
        </>,
        <>
          We have folks in South Korea and in the U.S. We welcome everyone to step outside of their boundaries and make
          impact cross-functionally.
        </>,
      ],
    },
    {
      title: ['오피스', 'Office'],
      main: [<>전 세계가 링글의 오피스입니다</>, <>The world is our office</>],
      description: [
        <>
          링글팀은 서울 테헤란로에 본사를, 미국 실리콘밸리에 지사를 두고 있습니다.
          {isMobile || <br />} 링글팀원들은 두 지역 외에도, 시드니, 런던, 시애틀, 펜실베니아 등 전 세계 각지에서
          원격으로
          {isMobile || <br />} 협업 중입니다. 링글의 자유롭고 글로벌한 문화가 녹아있는 오피스들을 소개합니다.
        </>,
        <>
          Ringle has its headquarters in Seoul and in San Mateo, CA. We also have teammates working remotely from all
          over the world, at Sydney, London, Seattle, Pennsylvania and more.
        </>,
      ],
    },
    {
      title: ['Join Us', `Join Us `],
      main: [<>꿈꿔왔던 일과 팀, 링글에서 찾아보세요!</>, <>Live your dream at Ringle!</>],
      description: [
        <>
          링글은 전 세계 사람들의 필수재인 '교육'을 테마로, 글로벌 무대에서 통할 수 있는 서비스를 만들고 있습니다.
          {!isMobile && <br />} 서울-실리콘밸리를 오가며 근무하고, 글로벌 인재들과 협업하며,
          {!isMobile && <br />} 링글을 유니콘 그 이상의 글로벌 No.1 에듀테크 회사로 함께 만들어 주실 분들이 계시다면,
          {!isMobile && <br />} 링글팀에 조인해 보세요!
        </>,
        <>Work with us to create the number one global education service</>,
      ],
    },
  ]
  const { t } = useTranslation()
  const cultureText = [
    {
      idx: '01',
      title: ['상호 존중에 기반한 소통', 'Horizontal communication'],
      image_url: CULTURE_1,
      desc: [
        "링글팀에는 대표님, 팀장님의 호칭이 없습니다. 링글팀은 이름에 님을 붙여 서로 존대합니다. 링글팀원은 모두 어른이자 전문가로 대우받을 자격이 있으며, '모든 아이디어는 평등하다'는 철학에 바탕을 두고 있습니다.",
        `At Ringle, we believe every member ought to be respected as adults and professionals and our philosophy is based on the belief that all ideas are equal.`,
      ],
    },
    {
      idx: '02',
      title: ['자율에 기반한 복지/투자', 'Self-directed benefits'],
      image_url: CULTURE_2,
      desc: [
        "링글 구성원들은 '회사의 Interest 를 극대화 하는 방향'으로, 스스로 결정하고 행동합니다. 회사는 이 모든 결정 및 활동을 적극적으로 지원합니다. 링글에게 있어 복지는 팀원 개개인과 회사가 동반 성장하기 위한 투자입니다.",
        `Ringle team members self-organize to best achieve Ringle's mission. Ringle provides necessary support, tools and benefits to facilitate better work & growth.`,
      ],
    },
    {
      idx: '03',
      title: ['건강-업무 효율 간 밸런스', 'Work-life balance'],
      image_url: CULTURE_3,
      desc: [
        <>
          링글은 업무에 몰입할 수 있고, 모두 건강할 수 있는 환경을 추구합니다. {!isMobile && <br />} 협업 및 개인 업무에
          집중할 수 있는 오피스 공간을 운영 중이며, 건강식/프리미엄식 중심으로 간식/먹거리를 제공합니다.
        </>,
        `Ringle pursues creating a harmonious work-life balance. Our workspace balances private and co-working, and our snack bar is loaded with healthy options.`,
      ],
    },
  ]

  return (
    <div className="container">
      <Welcome />
      <Section
        isFirst={true}
        title={t(sectionTexts[0].title)}
        main={t(sectionTexts[0].main)}
        description={t(sectionTexts[0].description)}
      />
      <Section
        isFirst={false}
        title={t(sectionTexts[1].title)}
        main={t(sectionTexts[1].main)}
        description={t(sectionTexts[1].description)}
        content={<Great />}
      />
      <div ref={listRef}>
        <Section
          isFirst={false}
          title={t(sectionTexts[2].title)}
          main={t(sectionTexts[2].main)}
          description={t(sectionTexts[2].description)}
        />
        <div className="mb-[63px] grid grid-cols-1 gap-[16px] sm:grid-cols-3 sm:gap-[20px]">
          {departments.map((department, i) => {
            return <DepartmentCard department={department} key={i} />
          })}
        </div>
      </div>

      <Section
        isFirst={false}
        title={t(sectionTexts[3].title)}
        main={t(sectionTexts[3].main)}
        description={t(sectionTexts[3].description)}
      />

      {isMobile || <hr className="mb-16 border-black" />}

      <SubSection title="Main Office" />
      <Office
        imageUrl={OFFICE_SEOUL}
        title="Seoul"
        address={
          <>
            22, Seocho-daero 78-gil, Seocho-gu
            {isMobile ? <></> : <br />}
            Gangnam, Seoul, Korea
          </>
        }
        description={[
          <>
            서울의 중심 강남에 위치한 서울 오피스는 강남 풍경이 한 눈에 보이는, 채광이 좋은 서초홍우빌딩에 입지해
            있습니다.
          </>,
          <>
            Located at Gangnam, the center of Seoul, Ringle’s Seoul Office is in Seocho Hongwoo Building where it enjoys
            ample natural light and a grand view of Gangnam
          </>,
        ]}
      />
      <Office
        imageUrl={OFFICE_SANMATEO}
        title="San Mateo"
        address={
          <>
            400 Concar dr. San
            {isMobile ? <></> : <br />}
            Mateo CA
          </>
        }
        description={[
          <>링글 미국 지사는 실리콘밸리 내 스탠포드 대학교와 샌프란시스코 사이의 산마테오 WeWork 에 위치해 있습니다.</>,
          <>
            Ringle's U.S. branch is located at San Mateo WeWork, which is in between Stanford University and San
            Francisco, Silicon Valley
          </>,
        ]}
      />
      <SubSection title="Sub Office" />
      <div className="row">
        <SubOffice imageUrl={OFFICE_SYDNET} title="Sydney" description={<>Hyunyoung’s Home Office</>} />
        <SubOffice imageUrl={OFFICE_SEATTLE} title="Seattle" description={<>Jiyoung’s Home Office</>} />
        <SubOffice imageUrl={OFFICE_PENNSYLVANIA} title="Pennsylvania" description={<>Hyojin’s Home Office</>} />
        {isMobile && <EmptyBlock h={90} />}
      </div>
      <Section
        isFirst={false}
        title={t(sectionTexts[4].title)}
        main={t(sectionTexts[4].main)}
        description={t(sectionTexts[4].description)}
        content={
          <div className="mt-7 overflow-hidden">
            <img src={JOIN_US} className={classNames(isMobile ? 'h-250' : 'h-416', 'w-full object-cover')} />
          </div>
        }
      />
      {isMobile ? <EmptyBlock h={32} /> : <EmptyBlock h={148} />}
      {!isMobile && <SubSection title={['링글의 문화', `Ringle's Culture `]} />}
      <div className="row mb-7 justify-center">
        {isMobile && (
          <Col clx="col-8 px-0">
            <SubSection title={['링글의 문화', `Ringle's Culture `]} />
          </Col>
        )}
        {cultureText.map((item, i) => (
          <CultureSection item={item} key={i} />
        ))}
      </div>
      <HiringSection />
      <div className="mx-auto mt-72 text-center">
        <a href="https://career.ringleplus.com/" target="_blank" rel="noreferrer">
          <Button lg primary>
            {t(['상세 채용공고 확인하기', 'See Details (Written in Korean)'])}
          </Button>
        </a>
      </div>
    </div>
  )
}

const CultureSection = ({ item }: { item: any }) => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  const { t } = useTranslation()

  return (
    <>
      {isMobile ? (
        <Col clx="flex items-center mb-32 col-8 px-0">
          <div>
            <div className="text-h3 mb-2 font-medium text-black">{item.idx}</div>
            <div className="font-regular display-7 mb-12">{t(item.title)}</div>
            <div className="text-h6 text-gray-700">{t(item.desc)}</div>
          </div>
        </Col>
      ) : (
        <Col clx="flex justify-center items-center mb-8 col-10">
          <img src={item.image_url} style={{ maxWidth: '324px' }} />
          <div className="pl-24">
            <div className="h2 mb-0 font-medium text-black">{item.idx}</div>
            <h1 className="text-h1 mb-20 font-bold">{t(item.title)}</h1>
            <div className="text-gray-700">{t(item.desc)}</div>
          </div>
        </Col>
      )}
    </>
  )
}

const Index = ({ json, ogData, isMobileServer }: InitialProps) => {
  const isMobile = useIsMobile(isMobileServer)

  return (
    <div>
      <BasicHead ogData={ogData} />

      <DeviceSplit isMobile={isMobile} mobile={<MobileLandingNav />} desktop={<LandingNav />} />

      <VWContainer>
        <CenterContainer>
          <TeamBody departments={json} />
          <EmptyBlock h={100} />
        </CenterContainer>
      </VWContainer>

      <Footer />
    </div>
  )
}

Index.getInitialProps = async (context: NextPageContext) => {
  const json = await axiosGet(apis.ringleTeam.departments())
  const { lang = LOCALE_KO } = context.query
  const ogData = {
    title: lang == LOCALE_KO ? '링글 팀 소개' : 'Ringle Team',
    desc:
      lang == LOCALE_KO
        ? '링글은 누구나 영어의 장벽을 넘어 더 큰 기회를 잡을 수 있는 세상을 만듭니다'
        : 'Ringle team aims to become the world’s number one Edu-Tech company by creating a service that fosters true learning and growth through our selective tutors, contents and technology',
    image: TEAM_MAIN,
    ogUrl: getOgUrl({ lang, context }),
  }

  let userAgent: string | undefined

  if (context.req) {
    // if you are on the server and you get a 'req' property from your context
    userAgent = context.req.headers['user-agent'] // get the user-agent from the headers
  } else {
    userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
  }

  const isMobileServer = userAgent
    ? Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))
    : false

  return {
    json,
    ogData,
    isMobileServer,
  }
}

export default Index
